import type { SxProps, Theme } from '@mui/material/styles';

type SxItem = Exclude<SxProps<Theme>, ReadonlyArray<unknown>>;

export const normalizeSx = (sx?: SxProps<Theme>): SxItem[] => {
  if (Array.isArray(sx)) return sx as SxItem[];
  if (sx) return [sx as SxItem];
  return [];
};
